import React, { Component } from 'react'
import styled from 'styled-components'

import ErrorAdaptiveCard from './AdaptiveCardRenderer/ErrorAdaptiveCard'

const StyledErrorNotification = styled(ErrorAdaptiveCard)`
  margin-left: 5px;
  margin-right: 5px;
`

interface NotificationErrorBoundaryProps {
  children?: React.ReactNode
  fullscreen?: boolean
  notificationId?: string
}

class NotificationErrorBoundary extends Component<NotificationErrorBoundaryProps> {
  static getDerivedStateFromError() {
    return { jsError: { code: 'CLIENT-2' } }
  }

  state = { jsError: null }

  componentDidCatch() {
    //
  }

  render() {
    const { notificationId, fullscreen } = this.props
    const { jsError } = this.state
    if (jsError) {
      return <StyledErrorNotification error={jsError} id={notificationId} fullscreen={fullscreen} />
    }
    return this.props.children
  }
}

// @ts-expect-error
NotificationErrorBoundary.displayName = 'NotificationErrorBoundary'

export default NotificationErrorBoundary
